import { Box, styled } from '@mui/material';
import { spaceCadet } from '../../../../../../../../../../../../../utils/colors';

const StyledBox = styled(Box)({
  borderLeft: `1px solid ${spaceCadet[300]}`,
  paddingLeft: 16,
});

export default StyledBox;
